/**
 * Nightlight — ad & analytics IDs (replace placeholders before going live).
 * Upload this folder to Shopify Files; paths stay relative to your page URL.
 */
window.NL_TRACKING = {
  enabled: true,

  /**
   * Shopify product or /cart/VARIANT:1 URL — set in Theme settings (Nightlight funnel)
   * or paste here. CTAs use this for native Shopify checkout.
   */
  /** Filled by theme (cart permalink /cart/VARIANT:1) — do not use bare /checkout */
  shopifyCheckoutUrl: "",

  meta: {
    pixelId: "YOUR_META_PIXEL_ID",
  },

  google: {
    /** Google Ads conversion tag, e.g. AW-123456789 */
    adsId: "AW-XXXXXXXXX",
    /** Optional GA4 property */
    ga4Id: "G-XXXXXXXXXX",
    /** Create in Google Ads → Goals → Conversions → website → copy send_to label */
    purchaseConversionLabel: "YOUR_PURCHASE_CONVERSION_LABEL",
    leadConversionLabel: "",
  },

  tiktok: {
    pixelId: "",
  },

  pinterest: {
    tagId: "",
  },

  product: {
    name: "Nightlight: The First Thirty Days",
    id: "nightlight-first-30",
    defaultValue: 27,
    currency: "USD",
  },

  /** Simple gate for admin/conversions.html — change PIN before production */
  adminPin: "nightlight2026",
};
